import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_Download",
  "use": "Ico_Download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Ico_Download\">\n    <path data-name=\"Union 7\" d=\"M4 21v-1h16v1zm7.68-3.645-5.032-5 .7-.71 4.18 4.153V3h1v12.788l4.114-4.14.709.7-4.968 5a.5.5 0 0 1-.707 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol